module.exports = __webpack_public_path__ + "static/media/Unilever.43fc253c.bmp";